import { useRef, useState } from "react";
import { ImagePlus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function LogoBar({ slot, project, onChange, onInsert }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      await api.post(`/projects/${slot}/logo`, fd);
      toast.success("Logo uploaded");
      onChange();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); ref.current.value = ""; }
  };

  const remove = async () => {
    await api.delete(`/projects/${slot}/logo`);
    toast.success("Logo removed");
    onChange();
  };

  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-background px-3 py-2" data-testid="logo-bar">
      <div className="h-10 w-24 rounded bg-white border border-border grid place-items-center overflow-hidden shrink-0">
        {project.logo_url ? <img src={project.logo_url} alt="Company logo" className="max-h-9 max-w-[88px] object-contain" data-testid="logo-thumbnail" />
          : <span className="text-[10px] text-muted-foreground">No logo</span>}
      </div>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="logo-upload-button"
          className="px-3 py-1.5 rounded-md border border-border bg-card hover:bg-secondary flex items-center gap-1.5">
          <ImagePlus className="h-3.5 w-3.5" />{busy ? "Uploading…" : project.logo_url ? "Replace logo" : "Upload company logo"}
        </button>
        {project.logo_url && onInsert && (
          <button type="button" onClick={onInsert} data-testid="logo-insert-button"
            className="px-3 py-1.5 rounded-md border border-primary/30 bg-primary/10 text-indigo-700 hover:bg-primary/20 font-mono">Insert {"{logo}"}</button>
        )}
        {project.logo_url && (
          <button type="button" onClick={remove} data-testid="logo-remove-button" className="px-2 py-1.5 text-rose-700 hover:underline flex items-center gap-1">
            <Trash2 className="h-3.5 w-3.5" />Remove
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept=".png,.jpg,.jpeg,.gif,.webp" className="hidden" data-testid="logo-file-input" onChange={(e) => upload(e.target.files[0])} />
    </div>
  );
}
